module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('footer', {
    staticClass: "footer"
  }, [_c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "row align-items-center flex-row-reverse"
  }, [_c('div', {
    staticClass: "col-auto ml-lg-auto"
  }), _vm._v(" "), _c('div', {
    staticClass: "col-12 col-lg-auto mt-3 mt-lg-0 text-center"
  }, [_vm._v("\n        © "), _c('span', {
    domProps: {
      "innerHTML": _vm._s(new Date().getFullYear())
    }
  }), _vm._v(" \n        "), _c('a', {
    attrs: {
      "href": "https://ascense.ca/",
      "target": "_blank"
    }
  }, [_vm._v("Ascense solutions technologiques")])])])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-30e606dd!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Footer.vue
// module id = 571
// module chunks = 2